import { Link } from "react-router";
import { Button } from "../../components/ui/button";
import { AlertCircle } from "lucide-react";

const UnauthorizedScreen = () => {
  return (
    <div className="text-center">
      <div className="mb-8 flex justify-center">
        <AlertCircle className="h-20 w-20 text-destructive" />
      </div>

      <h2 className="text-2xl font-bold text-foreground mb-2">Access Denied</h2>
      <p className="text-muted-foreground mb-6">
        You don't have permission to access this page. Please log in with an
        account that has the required permissions.
      </p>

      <div className="flex flex-col space-y-4">
        <Button asChild variant="default">
          <Link to="/">Go to Homepage</Link>
        </Button>

        <Button asChild variant="outline">
          <Link to="/dashboard">Go to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedScreen;
